const rollbarConfig = {
  rollbarAccessToken: 'ce4ee9eb5bef44329013963bc7b9b159'
  // Other configuration values can go here
};

export default rollbarConfig;